// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","input":"Input_input__3uLFF"};